import React, { useEffect, useState } from "react";
import { ProgressCircle, Text } from "@tremor/react";

export default function Gauge({ highlight, capability }) {
  const [value, setValue] = useState(capability.value);
  const [percentValue, setPercentValue] = useState(0);

  // clean up value before displaying
  const cleanValue = (value) => {
    if (value && (typeof value === "number")) {
      return value.toFixed(2);
    } else if (typeof value === "string" && !isNaN(value)) {
      return parseFloat(value).toFixed(2);
    }
  }

  // adjust value to be within 0 and 100 percent ratio
  useEffect(() => {
    const min = capability.widget.min || 0;
    const max = capability.widget.max || 100;
    const currentValue = capability.value || 0;
    
    // Handle edge cases
    if (min >= max) {
      // If min >= max, treat as 0-100 range or show 0%
      setPercentValue(0);
      setValue(currentValue);
      return;
    }
    
    // Calculate percentage with bounds checking
    let newPercentValue = ((currentValue - min) / (max - min)) * 100;
    
    // Clamp percentage between 0 and 100
    newPercentValue = Math.max(0, Math.min(100, newPercentValue));
    
    setPercentValue(Math.round(newPercentValue));
    setValue(currentValue);
  }, [capability.value, capability.widget.min, capability.widget.max]);

  return (
    <div className="flex flex-col items-center justify-center mt-2 h-full">
      <ProgressCircle value={percentValue} radius={64} size="lg">
        <span className="text-md font-medium text-slate-700 dark:text-slate-300">
          {cleanValue(value)}
        </span>
        <span className="text-md font-medium text-slate-700 dark:text-slate-300 ml-1">
          {capability.unit}
        </span>
      </ProgressCircle>
      <Text className="mt-2">{capability.type}</Text>
    </div>
  );
}
